import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useInstrument } from "../contexts/InstrumentContext";

/** Redirige al selector diario si aún no eligió instrumento hoy. */
export const RequireInstrumentSession: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { needsInstrumentPick } = useInstrument();
  const location = useLocation();

  if (needsInstrumentPick && location.pathname !== "/instrument") {
    const returnTo = `${location.pathname}${location.search}`;
    return <Navigate to="/instrument" replace state={{ from: returnTo }} />;
  }

  return <>{children}</>;
};
